import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Box, Button, Link } from "@mui/material";
import { useForm } from "react-hook-form";
import InputWrapper from "../../../../../obps/src/pages/citizen/AVPForms/layout/inputWrapper";
import { useHistory } from "react-router-dom";
import { Toast } from "@egovernments/digit-ui-react-components";

const ForgotPasswordRecovery = () => {
  const { control, handleSubmit, watch } = useForm();
  const tenant = Digit.ULBService.getStateId();
  const [mobileNumber, setMobileNumber] = useState("");
  const [userDetails, setUserDetials] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [showToast, setShowToast] = useState(null);

  const navigate = useHistory();

  const userName = watch("employeeId");

  const onSubmit = async (data) => {
    const otp = {
      otp: data.otp,
      UUID: userDetails?.uuid,
      isValidationSuccessful: true,
      tenantId: tenant,
      identity: mobileNumber,
    };

    try {
      const response = await Digit.UserService.otpValidate({ otp });
      console.log(response, "responseeeddee");
      // Navigate only after successful authentication
      if (response?.otp?.isValidationSuccessful) {
        navigate.push("/digit-ui/employee/user/reset-password", {
          otp: response.otp.otp,
          tenantId: response.otp.tenantId,
          mobileNumber: response.otp.identity,
          uuid: response.otp.UUID,
          userType: "employee",
        });
      }
    } catch (err) {
      console.error("Authentication Error:", err);
      const errorMessage =
        err?.response?.data?.error?.fields?.[0]?.message ||
        err?.response?.data?.error?.message ||
        err?.message ||
        "Unable to authenticate user. Please try again.";

      setShowToast({
        error: true,
        message: errorMessage,
      });
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const handleOtpRecovery = async () => {
    if (!userName) {
      setShowToast({ error: true, message: "Please enter Employee Id" });
      return;
    }
    setOtpSent(false);

    try {
      // 1️⃣ Fetch user details
      const usersResponse = await Digit.UserService.openUserSearch(tenant, { userName });

      if (!usersResponse?.user || usersResponse?.user?.length === 0) {
        throw new Error("User not found");
      }

      const mobile = usersResponse?.user?.[0]?.mobileNumber;
      setUserDetials(usersResponse?.user?.[0]);
      if (!mobile) {
        throw new Error("Mobile number not linked with user");
      }

      setMobileNumber(mobile);

      // 2️⃣ Send OTP
      const otpPayload = {
        mobileNumber: mobile,
        tenantId: tenant,
        type: "login",
        userType: "employee",
      };

      await Digit.UserService.sendOtp({ otp: otpPayload }, tenant);

      // 3️⃣ Success state
      setOtpSent(true);
    } catch (err) {
      console.error("OTP Recovery Error:", err);
      setShowToast({ error: true, message: err?.message || "Something went wrong while sending OTP" });
    }
  };

  const getMaskedMobile = (number) => {
    if (!number) return "";
    return `******${number.slice(-4)}`;
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" sx={{ backgroundColor: "#0F4C75" }}>
      <Card sx={{ width: 420, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" align="center" fontWeight="bold" gutterBottom>
            FORGOT PASSWORD
          </Typography>

          <Typography variant="body2" align="center" color="text.secondary" mb={3}>
            Please enter your details to reset your password.
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)}>
            <InputWrapper
              control={control}
              label="Enter Employee ID"
              name="employeeId"
              type="textInput"
              placeholder="Employee ID"
              mandatory
              width={390}
              validation={{
                required: {
                  value: true,
                  message: "Employee ID is required",
                },
              }}
            />
            <Box mt={2}>
              <Button
                fullWidth
                variant="contained"
                type="button"
                onClick={handleOtpRecovery}
                sx={{
                  backgroundColor: "#1F4A7C",
                  "&:hover": {
                    backgroundColor: "#163A63",
                  },
                }}
              >
                SEND OTP
              </Button>
            </Box>
            {otpSent && (
              <Typography variant="body2" color="success.main" align="center" mt={2}>
                OTP has been sent to {getMaskedMobile(mobileNumber)}
              </Typography>
            )}

            {otpSent && (
              <Box mt={3}>
                <InputWrapper
                  control={control}
                  label="Enter OTP"
                  name="otp"
                  placeholder="OTP"
                  width={390}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "OTP is required",
                    },
                  }}
                />
              </Box>
            )}

            {otpSent && (
              <Box mt={3}>
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  sx={{
                    backgroundColor: "#1F4A7C",
                    "&:hover": {
                      backgroundColor: "#163A63",
                    },
                  }}
                >
                  SUBMIT
                </Button>
              </Box>
            )}
          </form>

          <Box mt={2} textAlign="center">
            <Link href="/digit-ui/citizen" underline="hover">
              Back to Login Page
            </Link>
          </Box>
        </CardContent>
        {showToast && (
          <Toast error={showToast?.error} warning={showToast?.warning} label={showToast?.message} onClose={closeToast} isDleteBtn={true} />
        )}
      </Card>
    </Box>
  );
};

export default ForgotPasswordRecovery;
